import { type ClassValue, clsx } from "clsx"
import type { FieldError } from "react-hook-form"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function toFieldError(
  message: string | string[] | undefined,
): FieldError | undefined {
  if (!message) return undefined
  const text = Array.isArray(message) ? message.join(", ") : message
  return text ? { message: text, type: "manual" } : undefined
}
